import { CatExpertRouterLink } from '../../app-routing-enum';



export const studioSidemenuStatic = [
  {
    label: "STUDIO.HOME",
    icon: "icon-home2",
    slug: "/",
    activeSlug: CatExpertRouterLink.Studio
  },
  {
    label: "STUDIO.MY_EXPERIMENTS",
    icon: "icon-my-experiments",
    slug: CatExpertRouterLink.Experiments,
    activeSlug: CatExpertRouterLink.Experiments
  },
  {
    label: "STUDIO.SHARED",
    icon: "icon-shared",
    slug: `${CatExpertRouterLink.Experiments}/${CatExpertRouterLink.Shared}`,
    activeSlug: CatExpertRouterLink.Shared
  },
  {
    label: "STUDIO.PUBLISHED",
    icon: "icon-published",
    slug: `${CatExpertRouterLink.Experiments}/${CatExpertRouterLink.Published}`,
    activeSlug: CatExpertRouterLink.Published
  }
];

export const studioSidemenuStaticBulkPlano = [
  {
    label: "STUDIO.EXPERIMENT_SETUP",
    slug: CatExpertRouterLink.ExperimentSetup,
    activeSlug: CatExpertRouterLink.ExperimentSetup,
    icon: "https://cdn.catexpert.ab-inbev.com/assets/images/file-chart-line.svg"
  },
  {
    label: "STUDIO.DEFINE_SCOPE",
    slug: CatExpertRouterLink.DefineScope,
    activeSlug: CatExpertRouterLink.DefineScope,
    icon: "https://cdn.catexpert.ab-inbev.com/assets/images/Group-left-sidebar1.svg"
  },
  {
    label: "STUDIO.FIXTURE_LIBRARY",
    slug: CatExpertRouterLink.PlanoFixtureLibrary,
    activeSlug: CatExpertRouterLink.PlanoFixtureLibrary
  },
  {
    label: "STUDIO.PRODUCT_LIBRARY",
    slug: CatExpertRouterLink.PlanogramProductLibrary,
    activeSlug: CatExpertRouterLink.PlanogramProductLibrary
  },
  {
    label: "STUDIO.GOLDEN_RULES",
    slug: CatExpertRouterLink.GoldenRules,
    activeSlug: CatExpertRouterLink.GoldenRules
  },
  {
    label: "STUDIO.PLANOGRAM_SUMMARY",
    slug: CatExpertRouterLink.PlanogramSummary,
    activeSlug: CatExpertRouterLink.PlanogramSummary,
    icon: "https://cdn.catexpert.ab-inbev.com/assets/images/file-chart-line.svg"
  }
];

